// 引入vue
import Vue from 'vue'
// 引入Vuex
import Vuex from 'vuex'
import select_book from './select_book'
import pre_reading_guide from './pre_reading_guide'
import study_center from './study_center'
import { getToken, setToken } from '@/utils/auth'
// import {changeSkin} from './specify_bg'
// 使用Vuex
Vue.use(Vuex)

// 创建并暴露store
export default new Vuex.Store({
    modules:{
        SelectBookAbout:select_book,//精选图书
        PreReadingGuide:pre_reading_guide,//阅前导读
        StudyCenter:study_center,//学习中心
        // changeSkin//换肤
    },
    state:{       
        account:getToken('account'),//机构Id
        // changeSkin
    },
    mutations:{    
     
        // 将getBizUserInfo后台接口返回的account存入store
        GETSCHOOLID(state,value){
            state.account=value
        }
    },
    actions:{
    
    }    
})